import React from 'react';
import { DrawerLoiLemareMob } from './DrawerLoiLemareMob';
import { useBreakpoint } from '@rakutenfrance/breakpoint';
export const DrawerLoiLemare = () => {
    const { breakpoint } = useBreakpoint();
    if (breakpoint === 'phone') {
        return React.createElement(DrawerLoiLemareMob, null);
    }
    return React.createElement("div", null, "Loi Lemaire desktop");
};
